// @ts-strict-ignore
import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'APP/Hooks/redux'
import MaterialIcon from 'react-native-vector-icons/MaterialIcons'

import ServiceButtonCard from 'APP/Components/ServiceButtonCard'
import { isWeb } from 'APP/Helpers/checkPlatform'
import Analytics from 'APP/Services/Analytics'
import I18n from 'APP/I18n'

import { useTheme } from 'styled-components/native'
import styled from 'styled-components/native'

const TakeATourContainer = styled(View)`
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const TakeATour = () => {
  const navigation = useNavigation()
  const eligibleServices = useSelector((state) => state?.patient?.profile?.eligibleServices) || {}
  const hasPrimaryCare = Object.keys(eligibleServices).includes('physical_health_consults_md_np')
  const { orderedEpisodes } = useSelector((state) => state.history)
  const theme = useTheme()

  // Not displaying on web since we don't have web assets for this carousel
  if (isWeb() || !hasPrimaryCare || orderedEpisodes?.length > 0) {
    return null
  }

  const onPress = () => {
    Analytics.trackEvent('button_click', {
      button_value: 'Take a tour',
    })
    navigation.navigate('takeATour')
  }

  return (
    <TakeATourContainer>
      {/* Technically not a "Service", but since it's a experiment it's worth reusing this ServiceButtonCard for simplicity  */}
      <ServiceButtonCard
        testID="TakeATourButtonCard"
        tag={
          <MaterialIcon
            name="star-outline"
            size={16}
            color={theme.colors.darkText}
            accessibilityRole="image"
          />
        }
        iconTitle={
          <MaterialIcon
            name="lightbulb-outline"
            size={24}
            color={theme.colors.accent}
            accessibilityRole="image"
          />
        }
        title={I18n.t('TakeATour.info.title')}
        description={I18n.t('TakeATour.info.description')}
        onPress={onPress}
      />
    </TakeATourContainer>
  )
}

export default TakeATour
